import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const DASHBOARD = {
  getCommodityData: {
    start: "GET_COMMODITY_DATA_START",
    success: "GET_COMMODITY_DATA_SUCCESS",
    error: "GET_COMMODITY_DATA_ERROR"
  }
};

export const getCommodityData = name => {
  return (dispatch, getState) => {
    dispatch({ type: DASHBOARD.getCommodityData.start, data: [] });
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url = `/ntrac/farmOverview/overviewDataByCommodity?farmId=${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }&harvestYearId=${harvestYearDetail().name}&commodityData=${name}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: DASHBOARD.getCommodityData.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/inventorystatus/action.js